export function nlToArr(nl) {
  return [...nl];
}
